export enum FEATURE_FLAGS {
    SpellingGrammarMetrics = "spelling_grammar_metrics",
    GrammarMetric = "grammar_metric",
    WritingIssuesFilter = "writing_issues_filter",
    InternalFeatureFlagToggler = "internal_feature_flag_toggler",
    Watchtower2_0 = "watchtower_2.0",
    Clickhouse = "clickhouse",
    HomeScreenPhaseTwo = "home_screen_phase_2",
    Watchtower2_0ThemeToggler = "watchtower_2.0_theme_toggler",
    EditAIScorecards = "edit_ai_scorecards",
    TagPastInteractions = "tag_past_interactions",
    AgentActivityMetricManipulation = "agent_activity_metric_manipulation",
    EdgetierChristmas = "edgetier-christmas",
    ViewAIContactReasonTags = "view_ai_contact_reason_tags",
    EditContactReasons = "edit_contact_reasons",
    WatchtowerAiAssistant = "watchtower_ai_assistant",
    AiChatShareLinks = "ai_chat_share_links",
    SpotlightExpansionM1 = "spotlight_expansion_m1",
    SpotlightExpansionM2 = "spotlight_expansion_m2",
    AgentActivityQuestionReportingM3 = "agent_activity_question_reporting_m3",
    AgentSpotlight = "agent_spotlight",
    SpotlightToolErrorRecovery = "spotlight_tool_error_recovery",
    AiChatSessionReplay = "ai_chat_session_replay",
    AiAssistantSessionManagement = "ai_assistant_session_management",
    CoachReviewRevisionProcessM1 = "coach_review_revision_process_m1",
    CoachReviewRevisionProcessM2 = "coach_review_revision_process_m2",
    CoachReviewStatuses = "coach_review_statuses",
    ExportReviewsTable = "export_reviews_table",
    Sonar2_0 = "sonar_2.0",
    CustomerSuccessSupportWidget = "customer_success_support_widget",
    HeatmapReviewerCalibrationM1 = "heatmap_reviewer_calibration_m1",
}

export interface IEdgeIdentity {
    identity_uuid: string;
    identifier: string;
    dashboard_alias: string;
}

export interface IEdgeIdentityFeatureState {
    feature: {
        id: number;
        name: string;
        type: string;
    };
    enabled: boolean;
    feature_state_value: string | null;
    overridden_by: "IDENTITY" | "SEGMENT" | null;
    segment: { id: number; name: string } | null;
    multivariate_feature_state_values: Array<string>;
}
